import { CalendarIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import React from "react";
import { dateFormatter } from "utils/helpers";

interface CustomProps {
  value:string
}

const CreatedDate: React.FC<CustomProps> = ({ value }) => {
  return (
    <>
      <button className="flex items-center  hover:border hover:border-[#BDC0C3] p-[4px] rounded-[2px] min-w-max cursor-pointer ">
        <CustomTooltip text="Creation date" className="flex items-center ">
          <div className="flex items-center gap-2 w-full">
            <CalendarIcon size={16} />
            <span className="text-xs font-normal text-black">{dateFormatter(value)}</span>
          </div>
        </CustomTooltip>
      </button>
    </>
  );
};

export default CreatedDate;
